// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_fp-1";
export var quotedThread = "_fp-0";